// @ts-nocheck -- staged migration: add explicit types before removing this directive.
// Maps a WaniKani assignment's srs_stage (0-9) to a display label and color.
// Colors mirror the tokens in src/styles/_variables.scss ($colorSrs*) — kept
// in sync manually since these are also needed as plain values for inline
// tile-tint styles.
export const wanikaniSrsStages = [
    { stage: 0, label: "Not started", group: "none", color: "#94a3b8" },
    { stage: 1, label: "Apprentice I", group: "apprentice", color: "#dd0093" },
    { stage: 2, label: "Apprentice II", group: "apprentice", color: "#dd0093" },
    { stage: 3, label: "Apprentice III", group: "apprentice", color: "#dd0093" },
    { stage: 4, label: "Apprentice IV", group: "apprentice", color: "#dd0093" },
    { stage: 5, label: "Guru I", group: "guru", color: "#882d9e" },
    { stage: 6, label: "Guru II", group: "guru", color: "#882d9e" },
    { stage: 7, label: "Master", group: "master", color: "#294ddb" },
    { stage: 8, label: "Enlightened", group: "enlightened", color: "#d4a017" },
    { stage: 9, label: "Burned", group: "burned", color: "#434343" },
];

const stageByNumber = new Map(wanikaniSrsStages.map((entry) => [entry.stage, entry]));

export function getSrsStageInfo(srsStage) {
    return stageByNumber.get(srsStage) || stageByNumber.get(0);
}
